import { render, staticRenderFns } from "./LiveEventsHeader.vue?vue&type=template&id=acadc338&scoped=true&"
import script from "./LiveEventsHeader.vue?vue&type=script&lang=js&"
export * from "./LiveEventsHeader.vue?vue&type=script&lang=js&"
import style0 from "./LiveEventsHeader.vue?vue&type=style&index=0&id=acadc338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acadc338",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
